module.exports = __webpack_public_path__ + "media/images/star-off-c6c719a1.svg";